// src/pages/CommunityDesktop.jsx
import React, { useMemo, useState } from "react";
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderDesktop from "../_components/_global/HeaderDesktop";

function useScopeId(prefix = "cmd") {
    return useMemo(() => `${prefix}-${Math.random().toString(36).slice(2, 8)}`, [prefix]);
}

// Tabs
const TABS = [
    { key: "route", label: "Travel Routes", icon: "bi-map" },
    { key: "review", label: "Reviews", icon: "bi-chat-square-text" },
    { key: "events", label: "Local Events", icon: "bi-calendar2-event" },
];

// Demo posts 
const POSTS = [
    // --- Travel Routes ---
    {
        id: "p1",
        category: "route",
        user: { name: "Alex Chen", city: "Montreal", initials: "AC" },
        time: "2 hours ago",
        text:
            "Just discovered an amazing hidden alley near the Forbidden City! Local street food here is incredible.",
        media: ["https://static.seeker.io/media/img/1/a03612f1-73a9-4f3a-b7fa-53b475c137a4-1400.jpg?placeid=3790&name=Gay%20Village,%20Montreal&lat=45.52129&lng=-73.557983", "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRC9oS4XH73bpoFnsrgjfYcN9NL9unnNHH1Ug&s", "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQioZzpwe-eqRNJHrfmwRIlGTZ6VxVRmbciFw&s"],
        tags: ["Hidden Gems", "Street Food", "Monreal"],
        stats: { likes: 42, comments: 12, shares: 1 },
        rightActions: true,
    },
    {
        id: "p2",
        category: "route",
        user: { name: "Maria Rodriguez", city: "Calgary", initials: "MR" },
        time: "4 hours ago",
        text:
            "3-day Carlgary itinerary complete! Here's my detailed route with must-visit spots and local tips.",
        ribbon: { tone: "info", items: ["Travel Route", "3 days", "15 stops"] },
        tags: ["Itinerary", "Carlgary", "First Time"],
        stats: { likes: 89, comments: 23, shares: 1 },
        bookmark: true,
    },
    {
        id: "p6",
        category: "route",
        user: { name: "Ethan Moore", city: "Toronto", initials: "EM" },
        time: "1 day ago",
        text:
            "Toronto in 48 hours: CN Tower, Distillery District, waterfront biking, and a food crawl on Queen St.",
        ribbon: { tone: "info", items: ["Travel Route", "2 days", "10 stops"] },
        media: ["https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQyohB5u_sdaxvklR__TSd4dEk8QVpsNOMFRQ&s", "https://res.cloudinary.com/see-sight-tours/image/upload/v1725021088/strapi/4_18a270853f.png", "https://lp-cms-production.imgix.net/2023-02/The%20Gooderham%20Building%20%28Flatiron%29%2C%20a%20Romanesque%20style%20building%2C%20in%20East%20Toronto%20reflecting%20in%20a%20puddle%20on%20a%20wet%20rainy%20day%20in%20the%20Financial%20District%20Scott%20Heaney%20shutterstock_1564653259%20rfc.jpg?auto=format,compress&q=72&w=1095&fit=crop&crop=faces,edges"],
        tags: ["Toronto", "City Highlights", "Biking"],
        stats: { likes: 134, comments: 19, shares: 4 },
    },
    {
        id: "p7",
        category: "route",
        user: { name: "Ava Thompson", city: "Vancouver", initials: "AT" },
        time: "1 day ago",
        text:
            "Vancouver nature & food route: Seawall loop, Stanley Park totem poles, sushi at Denman, sunset at Kits.",
        ribbon: { tone: "info", items: ["Travel Route", "1 day", "8 stops"] },
        media: ["https://media.nomadicmatt.com/2023/vancouverstay.jpeg", "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBhotB--2VzxwAMrbQ0UU3riPxhRuiTEGwqQ&s", "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5BfX4TYFoEJbTkf6kKt537y27Wsatrhur8g&s"],
        tags: ["Vancouver", "Seawall", "Stanley Park"],
        stats: { likes: 98, comments: 14, shares: 3 },
    },
    {
        id: "p8",
        category: "route",
        user: { name: "Noah Martin", city: "New York", initials: "NM" },
        time: "2 days ago",
        text:
            "NYC first-timer route: Central Park → The Met → 5th Ave → Top of the Rock → Times Square night shots.",
        ribbon: { tone: "info", items: ["Travel Route", "1 day", "7 stops"] },
        media: ["https://fullsuitcase.com/wp-content/uploads/2022/05/One-day-in-New-York-USA-NYC-day-trip-itinerary.jpg", "https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/New_york_times_square-terabass.jpg/1200px-New_york_times_square-terabass.jpg", "https://assets.simpleviewinc.com/simpleview/image/upload/c_fill,h_348,q_75,w_618/v1/clients/newyorkstate/_cbudzruns_0befe10b-4884-484e-9673-846d2392035b.jpg"],
        tags: ["New York", "First Time", "Photography"],
        stats: { likes: 221, comments: 37, shares: 6 },
    },
    {
        id: "p9",
        category: "route",
        user: { name: "Liam Garcia", city: "Los Angeles", initials: "LG" },
        time: "2 days ago",
        text:
            "LA seaside weekend: Santa Monica Pier rides, Venice Canals stroll, tacos on Abbot Kinney, Malibu sunset.",
        ribbon: { tone: "info", items: ["Travel Route", "2 days", "9 stops"] },
        media: ["https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcStcnmwcE5_SfTfNV2X3AsNkNCGEuwNtClboA&s", "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_J0XVF_04KlWJyuTC7JvbHMi2VzIA0gavnA&s", "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ6bfI4pZdrp84-iuhC-6gKkXWWgdBT21GdRw&s"],
        tags: ["Los Angeles", "Beach", "Weekend"],
        stats: { likes: 143, comments: 22, shares: 5 },
    },

    // --- Reviews / Guides ---
    {
        id: "p3",
        category: "review",
        user: { name: "David Kim", city: "Guangzhou", initials: "DK" },
        time: "6 hours ago",
        text:
            "Dim sum crawl in Guangzhou—8 restaurants in one day! Here are my rankings and recommendations.",
        media: ["https://content.r9cdn.net/rimg/dimg/87/07/2a86d6b1-city-17708-17ea24f8693.jpg?width=1200&height=630&xhint=1566&yhint=937&crop=true", "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQmPIuXtkpLFG5aW5f2WhEA3d4In-9mvOmEjg&s", "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ0A2WIfJlS7GCnGCvQ_xhk9uPu7j6kN_jtvQ&s", "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqmV-c3DiUmgsQNUT6d4_-LwVGcMnKFrLysw&s"],
        tags: ["Food Tour", "Dim Sum", "Guangzhou"],
        stats: { likes: 156, comments: 34, shares: 2 },
    },
    {
        id: "p4",
        category: "review",
        user: { name: "Sophie Wang", city: "Chengdu", initials: "SW" },
        time: "8 hours ago",
        text:
            "Panda Base visit tips! Best times to go, photo spots, and how to avoid crowds. Plus my spicy noodle picks!",
        ribbon: { tone: "success", items: ["Travel Guide", "4.9 rating"] },
        tags: ["Animals", "Photography", "Chengdu", "Tips"],
        stats: { likes: 203, comments: 45, shares: 3 },
        bookmark: true,
    },
    {
        id: "p5",
        category: "review",
        user: { name: "James Liu", city: "Hangzhou", initials: "JL" },
        time: "12 hours ago",
        text:
            "West Lake at sunrise—absolutely magical! My photography guide and secret spots locals rarely share.",
        media: ["https://lp-cms-production.imgix.net/2019-06/ba95cdf517618ec301ab02ba3e86a912-hangzhou.jpg?auto=format,compress&q=72&w=1095&fit=crop&crop=faces,edges", "https://www.thechinajourney.com/wp-content/uploads/2024/09/hangzhou-photo-for-pc-banner-1024x576.webp", "https://f6d3w8j9.delivery.rocketcdn.me/wp-content/uploads/2017/10/hangzhou-1871458_1920.jpg"],
        tags: ["West Lake", "Photography", "Sunrise"],
        stats: { likes: 98, comments: 17, shares: 1 },
    },
    {
        id: "p10",
        category: "review",
        user: { name: "Charlotte Brown", city: "Banff", initials: "CB" },
        time: "1 day ago",
        text:
            "Banff & Lake Louise viewpoints list with parking tips. Moraine Lake shuttle experience and easy trails.",
        ribbon: { tone: "success", items: ["Travel Guide", "4.8 rating"] },
        media: ["https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRwJV5zrXElMUoQnvZVDAf6EsiZQV2_aVw3Ug&s", "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQVwP1qr5ExXDdz7kyrAOsUKhXDBujaHscEDA&s", "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSEEP9nshdoWX30V5c7XJ0cabrVCEQwdiwADg&s"],
        tags: ["Banff", "Lake Louise", "Hiking"],
        stats: { likes: 176, comments: 28, shares: 4 },
    },
    {
        id: "p11",
        category: "review",
        user: { name: "Isabella Nguyen", city: "Niagara Falls", initials: "IN" },
        time: "2 days ago",
        text:
            "Niagara Falls in a day—Maid of the Mist vs. Journey Behind the Falls, where to stand for the best spray.",
        ribbon: { tone: "success", items: ["Travel Guide", "4.7 rating"] },
        media: ["https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTAp7VYUXeqhIurQagTsZdYF_meZZfEE0aNtQ&s", "https://a.travel-assets.com/findyours-php/viewfinder/images/res70/51000/51237-Niagara-Falls-New-York.jpg", "https://tourstoniagarafalls.com/wp-content/uploads/2025/01/Niagara-Falls-Day-and-Evening-Tour-From-Toronto.jpg"],
        tags: ["Niagara Falls", "Boat Tour", "Viewpoints"],
        stats: { likes: 141, comments: 24, shares: 3 },
    },
    {
        id: "p12",
        category: "review",
        user: { name: "Mason Rivera", city: "Chicago", initials: "MR" },
        time: "2 days ago",
        text:
            "Chicago architecture photo spots with exact rooftops/bridges. Bonus: deep-dish ranking!",
        ribbon: { tone: "success", items: ["Travel Guide", "4.8 rating"] },
        media: ["https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT4UjkWdqOaA3pjUjmT1hVd4I1LLsh415JLZw&s", "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/26/df/65/c1/caption.jpg?w=1200&h=-1&s=1", "https://res.cloudinary.com/aenetworks/image/upload/c_fill,ar_2,w_3840,h_1920,g_auto/dpr_auto/f_auto/q_auto:eco/v1/gettyimages-584791924?_a=BAVAZGID0"],
        tags: ["Chicago", "Architecture", "Food"],
        stats: { likes: 119, comments: 20, shares: 2 },
    },
];

// ========== EVENTS: Local Events (15 items, each with image/link) ==========
const EVENTS = [
    { id: "e1", title: "Cherry Blossom Picnic", city: "Toronto", date: "Sat, Apr 20", time: "11:00–16:00", price: "Free", tags: ["Outdoor", "Family"], image: "https://images.unsplash.com/photo-1520975594081-0f8a1f25d2ca?q=80&w=1400&auto=format&fit=crop", link: "#" },
    { id: "e2", title: "Richmond Night Market", city: "Vancouver", date: "Fri, May 10", time: "18:00–23:30", price: "CA$8", tags: ["Food", "Market"], image: "https://images.unsplash.com/photo-1504754524776-8f4f37790ca0?q=80&w=1400&auto=format&fit=crop", link: "#" },
    { id: "e3", title: "Old Port Jazz Night", city: "Montreal", date: "Sun, Jun 2", time: "19:30–22:00", price: "CA$20", tags: ["Music", "Nightlife"], image: "https://images.unsplash.com/photo-1483412033650-1015ddeb83d1?q=80&w=1400&auto=format&fit=crop", link: "#" },
    { id: "e4", title: "SummerStage", city: "New York", date: "Sat, Jul 6", time: "17:00–21:30", price: "Free", tags: ["Concert", "Outdoor"], image: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?q=80&w=1400&auto=format&fit=crop", link: "#" },
    { id: "e5", title: "Food Truck Festival", city: "Los Angeles", date: "Sun, Aug 11", time: "12:00–20:00", price: "US$12", tags: ["Food", "Festival"], image: "https://images.unsplash.com/photo-1504754524776-8f4f37790ca0?q=80&w=1400&auto=format&fit=crop", link: "#" },
    { id: "e6", title: "Riverwalk Art Walk", city: "Chicago", date: "Sat, Sep 14", time: "10:00–18:00", price: "Free", tags: ["Art", "Market"], image: "https://images.unsplash.com/photo-1519681393784-d120267933ba?q=80&w=1400&auto=format&fit=crop", link: "#" },
    { id: "e7", title: "Lucha Libre Night", city: "Mexico City", date: "Fri, Oct 4", time: "20:00–22:30", price: "MX$180", tags: ["Show", "Nightlife"], image: "https://images.unsplash.com/photo-1535469420029-d460b2c7cf56?q=80&w=1400&auto=format&fit=crop", link: "#" },
    { id: "e8", title: "Street Food Fiesta", city: "San Francisco", date: "Sun, Oct 20", time: "12:00–19:00", price: "US$10", tags: ["Food", "Culture"], image: "https://images.unsplash.com/photo-1504754524776-8f4f37790ca0?q=80&w=1400&auto=format&fit=crop", link: "#" },
    { id: "e9", title: "Coffee Expo", city: "Seattle", date: "Sat, Nov 9", time: "09:30–17:30", price: "US$25", tags: ["Coffee", "Expo"], image: "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?q=80&w=1400&auto=format&fit=crop", link: "#" },
    { id: "e10", title: "Nuit Blanche", city: "Toronto", date: "Sat, Sep 28", time: "19:00–02:00", price: "Free", tags: ["Art", "Overnight"], image: "https://images.unsplash.com/photo-1519681393784-d120267933ba?q=80&w=1400&auto=format&fit=crop", link: "#" },
    { id: "e11", title: "Calgary Stampede", city: "Calgary", date: "Jul 5–14", time: "All Day", price: "CA$25", tags: ["Rodeo", "Festival"], image: "https://images.unsplash.com/photo-1483729558449-99ef09a8c325?q=80&w=1400&auto=format&fit=crop", link: "#" },
    { id: "e12", title: "Montreal Jazz Fest", city: "Montreal", date: "Jun 27–Jul 6", time: "Various", price: "Free+", tags: ["Music", "Festival"], image: "https://images.unsplash.com/photo-1483412033650-1015ddeb83d1?q=80&w=1400&auto=format&fit=crop", link: "#" },
    { id: "e13", title: "Halloween Parade", city: "New York", date: "Thu, Oct 31", time: "19:00–22:00", price: "Free", tags: ["Parade", "Costume"], image: "https://images.unsplash.com/photo-1541119638723-c51cbe2262aa?q=80&w=1400&auto=format&fit=crop", link: "#" },
    { id: "e14", title: "LA Hanami Festival", city: "Los Angeles", date: "Sun, Mar 30", time: "10:00–16:00", price: "US$15", tags: ["Culture", "Family"], image: "https://images.unsplash.com/photo-1520975594081-0f8a1f25d2ca?q=80&w=1400&auto=format&fit=crop", link: "#" },
    { id: "e15", title: "Chicago Marathon Expo", city: "Chicago", date: "Oct 10–12", time: "10:00–18:00", price: "Free", tags: ["Sport", "Expo"], image: "https://images.unsplash.com/photo-1520974735194-3b0f2c5c4f5f?q=80&w=1400&auto=format&fit=crop", link: "#" },
];


export default function CommunityDesktop() {
    const scope = useScopeId();
    const [active, setActive] = useState("route");
    const [query, setQuery] = useState("");
    const [view, setView] = useState("grid"); // grid|list
    const [favs, setFavs] = useState(new Set());

    const navigate = useNavigate();
    const { state } = useLocation();
    const cityName =
        state?.cityName ||
        state?.selectedCity ||
        localStorage.getItem("cityName") ||
        "Toronto";


    const css = `
  [data-cmd="${scope}"] .wrap{padding:16px 0 24px;}
  [data-cmd="${scope}"] .title{font-size:28px;font-weight:800;color:#0f1720;margin:6px 0 2px}
  [data-cmd="${scope}"] .subtitle{color:#6a7a8a;margin-bottom:12px}

  /* toolbar */
  [data-cmd="${scope}"] .toolbar{display:flex;align-items:center;gap:10px;flex-wrap:wrap;margin:8px 0 14px}
  [data-cmd="${scope}"] .tabs{display:flex;gap:8px;flex-wrap:wrap}
  [data-cmd="${scope}"] .chip{
    display:inline-flex;align-items:center;gap:6px;padding:8px 12px;border-radius:999px;
    background:#f6f8fb;border:1px solid #e7edf5;color:#0f1720;font-weight:600;cursor:pointer
  }
  [data-cmd="${scope}"] .chip i{font-size:15px}
  [data-cmd="${scope}"] .chip.active{background:#0f2538;color:#fff;border-color:#0f2538}
  [data-cmd="${scope}"] .search{position:relative;margin-left:auto;min-width:280px}
  [data-cmd="${scope}"] .search input{
    width:100%;height:40px;border:1px solid #e6eaf0;border-radius:12px;background:#f9fbfc;
    padding:0 12px 0 36px
  }
  [data-cmd="${scope}"] .search i{position:absolute;left:12px;top:50%;transform:translateY(-50%);color:#8aa0b3}
  [data-cmd="${scope}"] .btn-icon{width:40px;height:40px;border:1px solid #e7edf5;border-radius:12px;background:#fff;display:flex;align-items:center;justify-content:center}
  [data-cmd="${scope}"] .newpost{background:#0f2538;color:#fff;border:none;border-radius:12px;font-weight:700;padding:9px 12px}

  /* posts grid/list */
 [data-cmd="${scope}"] .post{ transition: box-shadow .18s ease; }
 [data-cmd="${scope}"] .post.list{ display:block; } /* list 模式下保持整行 */
  [data-cmd="${scope}"] .post .head{display:flex;align-items:center;gap:10px;padding:14px 16px 10px}
  [data-cmd="${scope}"] .avatar{width:36px;height:36px;border-radius:50%;background:#f0f2f6;border:1px solid #e7edf5;display:flex;align-items:center;justify-content:center;font-weight:700;color:#0f1720}
  [data-cmd="${scope}"] .name{font-weight:700;color:#0f1720}
  [data-cmd="${scope}"] .time{color:#6a7a8a;font-size:12px}
  [data-cmd="${scope}"] .city{padding:4px 8px;border-radius:999px;background:#eef4ff;color:#23408c;border:1px solid #dbe6ff;font-size:12px}
  [data-cmd="${scope}"] .more{margin-left:auto;color:#8aa0b3}

  [data-cmd="${scope}"] .body{padding:4px 16px 12px;color:#0f1720}
  [data-cmd="${scope}"] .media{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;padding:10px 16px}
  [data-cmd="${scope}"] .media .box{height:120px;border-radius:12px;background:#f4f6f9;border:1px solid #eef2f6;display:flex;align-items:center;justify-content:center;font-size:28px;color:#8ba0b4}
  [data-cmd="${scope}"] .media .box{ position:relative; overflow:hidden; }
[data-cmd="${scope}"] .media .box-img{
  width:100%; height:100%; object-fit:cover; display:block;
  transform:translateZ(0); transition: transform .25s ease;
}
[data-cmd="${scope}"] .post:hover .media .inner-fx .box-img{ transform: scale(1.03); } 
  [data-cmd="${scope}"] .tags{display:flex;flex-wrap:wrap;gap:8px;padding:8px 16px 0}
  [data-cmd="${scope}"] .tag{background:#eef2f7;color:#334354;border-radius:999px;padding:6px 10px;font-size:12px}
  [data-cmd="${scope}"] .ribbon{margin:8px 16px 0;padding:8px 12px;border-radius:10px;display:flex;gap:12px;align-items:center;font-size:14px}
  [data-cmd="${scope}"] .ribbon.info{background:#eef4ff;color:#23408c;border:1px solid #dbe6ff}
  [data-cmd="${scope}"] .ribbon.success{background:#eefcf2;color:#1f6a2d;border:1px solid #cdeccc}

  [data-cmd="${scope}"] .foot{display:flex;align-items:center;gap:16px;border-top:1px solid #eef2f6;padding:10px 16px;color:#6a7a8a}
  [data-cmd="${scope}"] .foot .stat{display:inline-flex;align-items:center;gap:6px;cursor:pointer}
  [data-cmd="${scope}"] .foot .stat i{font-size:16px}
  [data-cmd="${scope}"] .bookmark{margin-left:auto;color:#8aa0b3}

  /* === Local Events: flat line cards === */
[data-cmd="${scope}"] .ev-line{
  display:block;
  border:1px solid #e8edf2;
  border-radius:14px;
  background:#fff;
  overflow:hidden;
}
[data-cmd="${scope}"] .ev-line .inner{
  padding:14px 16px;
  display:flex; align-items:flex-start; justify-content:space-between; gap:12px;
  transition: transform .15s ease, box-shadow .15s ease;
  will-change: transform;
}
[data-cmd="${scope}"] .ev-line:hover .inner{
  transform: translateY(-2px);              /* ✅ 只动内容，容器尺寸不变 */
}
[data-cmd="${scope}"] .ev-tag{
  display:inline-flex; align-items:center; gap:6px;
  padding:6px 10px; border-radius:999px;
  background:#f6efff; color:#6b21a8; border:1px solid #eadcff;
  font-weight:700; font-size:12px;
}
[data-cmd="${scope}"] .ev-title{ margin-top:6px; font-weight:800; color:#0f1720; }
[data-cmd="${scope}"] .ev-desc{ margin-top:4px; color:#475569; font-size:14px; }
[data-cmd="${scope}"] .ev-date{ margin-top:10px; color:#64748b; font-size:12px; }
[data-cmd="${scope}"] .ev-venue{ color:#334155; font-weight:700; white-space:nowrap; }


  @media (max-width: 1400px){
    [data-cmd="${scope}"] .search{min-width:220px}
  }
  `;

    const isEvents = active === "events" || active === "event"; // ✅ 双写兼容
    const filteredPosts = !isEvents
        ? POSTS.filter(
            (p) =>
                p.category === active &&
                (p.text.toLowerCase().includes(query.toLowerCase()) ||
                    p.tags?.some((t) => t.toLowerCase().includes(query.toLowerCase())))
        )
        : [];

    const posts = !isEvents
        ? (filteredPosts.length ? filteredPosts : POSTS.filter((p) => p.category === active))
        : [];

    return (
        <>
            <style>{css}</style>

            <HeaderDesktop
                active="community"
                cityName={cityName}
                unread={3}
                maxWidth={1280}
                onSearch={(q) => navigate(`/explore?q=${encodeURIComponent(q)}&city=${encodeURIComponent(cityName)}`)}
            />


            <Container data-cmd={scope} className="wrap">
                {/* Header */}
                <div className="d-flex align-items-center justify-content-between">
                    <div>
                        <div className="title">Travel Community</div>
                        <div className="subtitle">Connect with fellow travelers and share your experiences</div>
                    </div>
                    <Button className="newpost">
                        <i className="bi bi-plus-lg me-1" /> New Post
                    </Button>
                </div>

                {/* Toolbar */}
                <div className="toolbar">
                    <div className="tabs">
                        {TABS.map((t) => (
                            <button
                                key={t.key}
                                className={`chip ${active === t.key ? "active" : ""}`}
                                onClick={() => setActive(t.key)}
                            >
                                <i className={`bi ${t.icon}`} /> {t.label}
                            </button>
                        ))}
                    </div>

                    <div className="search">
                        <i className="bi bi-search" />
                        <Form.Control
                            type="search"
                            placeholder="Search posts..."
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                        />
                    </div>
                    <button className="btn-icon" title="Filter">
                        <i className="bi bi-funnel" />
                    </button>
                    <button className="btn-icon" title={view === "grid" ? "Grid" : "List"} onClick={() => setView(view === "grid" ? "list" : "grid")}>
                        <i className={`bi ${view === "grid" ? "bi-grid-3x3-gap" : "bi-list"}`} />
                    </button>
                </div>

                {/* Posts grid */}
                {isEvents ? (
                    <Row className="g-3">
                        {EVENTS.map(ev => (
                            <Col key={ev.id} xl={6} lg={12}>

                                <a className="ev-line" href={ev.link || "#"} target="_blank" rel="noreferrer">
                                    <div className="inner">
                                        <div>
                                            <div className="ev-tag">
                                                <i className="bi bi-calendar-event" /> Local Event
                                            </div>
                                            <div className="ev-title">{ev.title}</div>
                                            <div className="ev-desc">
                                                {ev.desc || ev.summary || ev.subtitle || "Traditional performances, food stalls, and cultural activities"}
                                            </div>
                                            <div className="ev-date">{ev.date}</div>
                                        </div>
                                        <div className="ev-venue">
                                            {ev.venue || ev.location || ev.city}
                                        </div>
                                    </div>
                                </a>
                            </Col>
                        ))}
                    </Row>
                ) : (
                    <Row className="g-3 align-items-stretch">
                        {posts.map((p) => (
                            <Col
                                key={p.id}
                                // 👇 grid 布局：xl>=3列, lg=2列；切到 list 时整行
                                {...(view === "grid"
                                    ? { xxl: 4, xl: 4, lg: 6, md: 12 }   // 12/4=3列；想4列把 xxl 改成 3
                                    : { xl: 12, lg: 12, md: 12 })}
                            >
                                <Card className={`post h-100 ${view === "list" ? "list" : ""}`}>
                                    {/* head */}
                                    <div className="head">
                                        <div className="avatar">{p.user.initials}</div>
                                        <div>
                                            <div className="name">{p.user.name}</div>
                                            <div className="time">{p.time}</div>
                                        </div>
                                        <span className="city ms-2">{p.user.city}</span>
                                        <div className="more ms-auto"><i className="bi bi-plus-lg" /></div>
                                    </div>

                                    {/* body */}
                                    <div className="body">{p.text}</div>

                                    {/* ribbon meta */}
                                    {p.ribbon && (
                                        <div className={`ribbon ${p.ribbon.tone === "success" ? "success" : "info"}`}>
                                            {p.ribbon.items.map((it) => (
                                                <span key={it}>
                                                    <i className={`bi ${p.ribbon.tone === "success" ? "bi-star" : "bi-geo"}`} /> {it}
                                                </span>
                                            ))}
                                        </div>
                                    )}

                                    {/* media（支持图片URL；没有就用 emoji/占位） */}
                                    {p.media?.length ? (
                                        <div className="media">
                                            {p.media.slice(0, 3).map((m, i) => (
                                                <div className="box inner-fx" key={i}>
                                                    {/^https?:\/\//.test(m) ? (
                                                        <img className="box-img" src={m} alt="" loading="lazy" />
                                                    ) : (
                                                        <span style={{ fontSize: 28 }}>{m}</span>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    ) : null}

                                    {/* tags */}
                                    {p.tags?.length ? (
                                        <div className="tags">
                                            {p.tags.map((t) => (
                                                <span className="tag" key={t}>#{t}</span>
                                            ))}
                                        </div>
                                    ) : null}

                                    {/* foot */}
                                    <div className="foot">
                                        <span className="stat"><i className="bi bi-heart" /> {p.stats.likes}</span>
                                        <span className="stat"><i className="bi bi-chat-dots" /> {p.stats.comments}</span>
                                        <span className="stat"><i className="bi bi-share" /></span>
                                        <span className="bookmark ms-auto">
                                            <i className={`bi ${p.bookmark ? "bi-bookmark-fill" : "bi-bookmark"}`} />
                                        </span>
                                    </div>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                )}

            </Container>
        </>
    );
}
